import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

import { NewTrialAccount } from '../models/trial.model';

@Injectable()
export class TrialService {
  plans: Array<string>;
  constructor(private http: HttpClient) {}

  submitTrial(account: NewTrialAccount) {
    return this.http.post(
      `${environment.apiEndpoint}/api/v1/account-creation-requests`,
      account
    );
  }

  pollingAccount(requestId: string) {
    return this.http.get(
      `${environment.apiEndpoint}/api/v1/account-creation-requests/${requestId}`
    );
  }

  getPlans() {
    return this.http.get(
      `${environment.apiEndpoint}/api/v1/subscriptions/plans`
    );
  }

  checkEmailExists(email: string) {
    return this.http.get(
      `${environment.apiEndpoint}/api/v1/users/${email}/exists`,
      { observe: 'response' }
    );
  }
}
